import React, { FC, ReactNode } from 'react';
import { useAuthState } from '@packages/contexts/auth';
import { getStisAccessState } from '@web/utils/can-view-stis';
import { StisAccessBlockedView } from '@web/components/stis-access-blocked-view';

interface StisAccessGateProps {
    children: ReactNode;
}

/**
 * Wraps any STIS content view. Checks the account's subscription access state
 * and either renders the content (INTERNAL_USER, ACTIVE, EXPIRING_SOON) or
 * the appropriate blocked view (EXPIRED, NO_SUBSCRIPTION, PENDING).
 *
 * Real STIS content is never fetched when access is blocked — the backend
 * (TECHSHARE-5328) enforces the entitlement, and the gate ensures no API call
 * is made from the client either. The blurred skeleton is purely cosmetic.
 */
export const StisAccessGate: FC<StisAccessGateProps> = ({ children }) => {
    const { account } = useAuthState();
    const accessState = getStisAccessState(account);

    if (accessState === 'EXPIRED' || accessState === 'NO_SUBSCRIPTION' || accessState === 'PENDING') {
        return <StisAccessBlockedView state={accessState} />;
    }

    return <>{children}</>;
};
